export const GET_REPORTS = 'GET_REPORTS';// 获取举报列表

export const GET_REPORT = 'GET_REPORT';// 获取举报信息

export const DELETE_REPORT = 'DELETE_REPORT';//删除举报

export const ASSIGN = 'CHANGE_REPORT_STATUS';//修改处理状态